module.exports = __webpack_public_path__ + "static/snowball-elliot-craig-v5-273ae18e39c65e020a3c1d1b7dce3f5e.mp4";